import { LightVisualizer } from './LightVisualizer.js';
import { LightPositionSphere } from './PositionSphere.js';
import { vector_3 } from '../../../utility/Conversion.js';
import { SpotlightShadowFrustumVisualizer } from '../../../debug/visualizers/SpotlightShadowFrustumVisualizer.js';
import { Color4 as BABYLON_Color4 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.color.js';
import { LineType } from '../../../../api.js';
import { clamp } from '../../../../Math.js';
export class SpotLightVisualizer extends LightVisualizer {
    constructor(light, line_manager, color_mode, scene, viewer) {
        super(light, line_manager, color_mode, scene);
        this._num_lines = 8;
        this._minimum_line_length = 0;
        this._position_sphere = new LightPositionSphere('SpotLight', scene);
        this._frustum_visualizer = new SpotlightShadowFrustumVisualizer(light, viewer, new BABYLON_Color4(0.5, 0.5, 0.8), 0.05, LineType.DASHED);
        this.update();
    }
    update() {
        super.update_visualizer();
        // We clamp it to prevent a number close to infinity when we calculate the tangent of a 90 degree angle
        const cone_end_radius = clamp(Math.tan(this._light.outer_angle_radians * 0.5) * this._light_range, -100, 100);
        const position = vector_3(this._light.get_world_position());
        const direction = vector_3(this._light.get_world_direction()).normalize();
        this.draw_directional_lines(this._light_range, cone_end_radius, 'cone', this._num_lines, direction, position, true);
        this._position_sphere.update(position, this._line_color);
        if (this._light.shadow.enable_shadows) {
            this._frustum_visualizer.update();
        }
        else {
            this._frustum_visualizer.remove_lines();
        }
    }
    dispose(start_index = 0) {
        this._position_sphere.dispose();
        this._frustum_visualizer.dispose();
        super.dispose(start_index);
    }
    remove_lines(start_index) {
        super.remove_lines(start_index);
        this._frustum_visualizer.remove_lines();
    }
}
//# sourceMappingURL=SpotLightVisualizer.js.map